const Bank = ({
  color = 'currentColor',
  size = 20,
}: {
  color?: string
  size?: number
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16667 7.50006V14.1667M7.91667 7.50006V14.1667M12.0833 7.50006V14.1667M15.8333 7.50006V14.1667M2.5 15.5001L2.5 16.1667C2.5 16.6334 2.5 16.8668 2.59083 17.045C2.67072 17.2019 2.79821 17.3293 2.95501 17.4092C3.13327 17.5001 3.36662 17.5001 3.83333 17.5001H16.1667C16.6334 17.5001 16.8667 17.5001 17.045 17.4092C17.2018 17.3293 17.3293 17.2019 17.4092 17.045C17.5 16.8668 17.5 16.6334 17.5 16.1667V15.5001C17.5 15.0333 17.5 14.8 17.4092 14.6217C17.3293 14.4649 17.2018 14.3374 17.045 14.2576C16.8667 14.1667 16.6334 14.1667 16.1667 14.1667H3.83333C3.36662 14.1667 3.13327 14.1667 2.95501 14.2576C2.79821 14.3374 2.67072 14.4649 2.59083 14.6217C2.5 14.8 2.5 15.0333 2.5 15.5001ZM9.71076 2.56433L3.54409 3.9347C3.17154 4.01749 2.98527 4.05889 2.84622 4.15906C2.72358 4.24742 2.62727 4.36747 2.56762 4.50636C2.5 4.66383 2.5 4.85465 2.5 5.23629L2.5 6.16672C2.5 6.63343 2.5 6.86679 2.59083 7.04505C2.67072 7.20185 2.79821 7.32933 2.95501 7.40923C3.13327 7.50006 3.36662 7.50006 3.83333 7.50006H16.1667C16.6334 7.50006 16.8667 7.50006 17.045 7.40923C17.2018 7.32933 17.3293 7.20185 17.4092 7.04505C17.5 6.86679 17.5 6.63343 17.5 6.16672V5.23629C17.5 4.85465 17.5 4.66383 17.4324 4.50636C17.3727 4.36747 17.2764 4.24742 17.1538 4.15906C17.0147 4.05889 16.8285 4.01749 16.4559 3.9347L10.2892 2.56433C10.1813 2.54035 10.1273 2.52835 10.0728 2.52357C10.0244 2.51932 9.97564 2.51932 9.9272 2.52357C9.87267 2.52835 9.8187 2.54035 9.71076 2.56433Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Bank
